import { Component, OnInit, Input } from "@angular/core";
import { WindowRef } from "../../window/WindowRef";
import { KpiService } from "../../kpi/kpi.service";
import { MatDialog } from "@angular/material/dialog";
import { LeaveSZConfirmDialogComponent } from "../leave-sz-confirm-dialog/leave-sz-confirm-dialog.component";

@Component({
  selector: "chart-icon-button",
  templateUrl: "./chart-icon-button.component.html",
  styleUrls: ["./chart-icon-button.component.scss"],
})
export class ChartIconButtonComponent implements OnInit {
  @Input() imgName: string;
  @Input() btnName: string;
  @Input() selected: boolean;
  @Input() disabled: boolean;
  @Input() url: string;
  @Input() kpiId: string;
  @Input() type: string;

  partialImagePath: string = "../../assets/images/";
  highlighted: boolean;
  disabledTooltip: string = "Coming soon!";

  constructor(
    public winRef: WindowRef,
    public kpiService: KpiService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {}

  selectBtn(type) {
    if (type == "otherReports") {
      this.kpiService.trackMetricZoomOtherReportsClicked().subscribe(
        (data) => {},
        (error) => {
          console.error(error);
        }
      );
      if (
        this.url.includes("schoolzilla.com") ||
        this.url.includes("renaissance.com") ||
        localStorage.getItem("leaveMosaicConfirmDialog") == "hidden"
      ) {
        // if going to schoolzilla link or user has selected not to see confirm dialog, navigate directly to other reports
        this.goToOtherReports();
      } else {
        // non-schoolzilla link
        this.openDialog();
      }
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(LeaveSZConfirmDialogComponent, {
      data: { url: this.url },
      width: "60rem",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.leaveMosaic) {
        this.goToOtherReports();
        if (result.hideModalChecked) {
          // save in local storage that the user doesn't want to see this modal again
          localStorage.setItem("leaveMosaicConfirmDialog", "hidden");
        }
      }
    });
  }

  goToOtherReports() {
    this.winRef.nativeWindow.open(
      !this.url.match(/^https?:\/\//i) ? "http://" + this.url : this.url,
      "_blank"
    );
  }
}
